import React from "react";
import { Box } from "@mui/material";

import { Body1SemiBold, CloseButton, Tabs } from "components";
import { UtilityBillFormViewForDocument } from "pages";
import { AddDataEntryWrapperProps } from "./types";

export const AddDataEntryWrapper: React.FC<AddDataEntryWrapperProps> = ({
  document,
  onClose,
}) => {
  const { fileName } = document;

  return (
    <>
      <Box
        sx={{
          width: "100%",
          height: "34px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          height: "34px",
        }}>
          <Body1SemiBold>
            Add bill to document: {fileName}
          </Body1SemiBold>
          <CloseButton onClick={onClose} variant="outlined" />
        </Box>
      </Box>
      <Box sx={{
        width: "100%",
        flexGrow: 1,
        overflow: "auto",
      }}>
        <Tabs
          activeTab={0}
          tabs={[{
            label: "ADD DOCUMENT BILL",
            content: (
              <Box>
                <Box sx={{ flexGrow: 1, overflow: "hidden" }}>
                  <UtilityBillFormViewForDocument
                    document={document}
                    onClose={onClose}
                  />
                </Box>
              </Box>
            ),
          }]}
        />
      </Box>
    </>
  );
};